package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.blog.BlogClosingSection
import com.anjuros.website.redesign.sections.blog.BlogGuidesSection
import com.anjuros.website.redesign.sections.blog.BlogHeroSection
import com.anjuros.website.redesign.sections.blog.blogStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun Blog() {
    val title = LocalText(RdText.BLOG_META_TITLE)
    val description = LocalText(RdText.BLOG_META_DESCRIPTION)
    val structuredData = blogStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.BLOG}")
        setJsonLd("ld-blog", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.BLOG))
        Main {
            BlogHeroSection()
            BlogGuidesSection()
            BlogClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
